  document.addEventListener("DOMContentLoaded", function() {
    const topbarSwiperEl = document.querySelector(".m-topbar__message-swiper");
    if (!topbarSwiperEl) return;

    const topbar = topbarSwiperEl.closest(".m-topbar");
    const swiper = new MinimogLibs.Swiper(topbarSwiperEl, {
      slidesPerView: 1,
      loop: true,
      touchRatio: 1,
      resistanceRatio: 0,
      freeMode: false,
      freeModeMomentum: false,

      grabCursor: true,

      speed: 100,

      autoplay: {
        delay: 7000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: "#topbar-next",
        prevEl: "#topbar-prev",
      },
      pagination: {
        el: topbarSwiperEl.querySelector(".swiper-pagination"),
        clickable: true,
      },

      on: {
        init(swpr) {
          const firstSlide = swpr.slides[swpr.activeIndex];
          const bgColor = firstSlide.dataset.color;
          if (bgColor) topbar.style.backgroundColor = bgColor;
        },
        slideChange(swpr) {
          const activeSlide = swpr.slides[swpr.activeIndex];
          const color = activeSlide.dataset.color;
          if (color) topbar.style.backgroundColor = color;
        },
      },
    });

    topbarSwiperEl.addEventListener("mouseenter", () => swiper.autoplay.stop());
    topbarSwiperEl.addEventListener("mouseleave", () => swiper.autoplay.start());
  });
